"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CounterTag = CounterTag;

var _classnames = _interopRequireDefault(require("classnames"));

var React = _interopRequireWildcard(require("react"));

var _index = require("../../index");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function CounterTag(_ref) {
  var className = _ref.className,
      count = _ref.count,
      intent = _ref.intent,
      interactive = _ref.interactive,
      minimal = _ref.minimal,
      _ref$outlineOnEmpty = _ref.outlineOnEmpty,
      outlineOnEmpty = _ref$outlineOnEmpty === void 0 ? false : _ref$outlineOnEmpty,
      style = _ref.style,
      text = _ref.text,
      tagProps = _objectWithoutProperties(_ref, ["className", "count", "intent", "interactive", "minimal", "outlineOnEmpty", "style", "text"]);

  var classes = (0, _classnames.default)(_defineProperty({}, _index.Classes.MINIMAL, minimal), className);
  var validCount = Number.isInteger(count);
  var nonZeroCount = validCount && count > 0;
  var showCount = outlineOnEmpty ? nonZeroCount : validCount;
  var isMutedOutline = outlineOnEmpty && !nonZeroCount;
  var defaultCounterTagProps = {
    interactive: interactive,
    round: true,
    large: true,
    style: _objectSpread(_objectSpread({}, style), showCount && {
      paddingRight: '4px'
    })
  };
  var counterTagProps;

  if (isMutedOutline) {
    counterTagProps = _objectSpread(_objectSpread({}, defaultCounterTagProps), {}, {
      intent: intent,
      outline: true
    });
  } else {
    counterTagProps = _objectSpread(_objectSpread({}, defaultCounterTagProps), {}, {
      intent: intent,
      minimal: minimal
    });
  }

  var captionProps = {
    style: {
      textTransform: 'capitalize' // color: isMutedOutline ? Colors.GREY_50 : minimal ? Colors.GREY_70 : Colors.WHITE

    }
  };
  /**
   * These colours have to be manually calculated because the indicator tags are one shade darker
   * than the normal default and minimal styles.
   */

  var colors = {
    danger: _index.Colors.RED_60,
    primary: _index.Colors.MARINE_60,
    none: _index.Colors.SAGE_60,
    success: _index.Colors.GREEN_60,
    warning: _index.Colors.YELLOW_60
  };
  var indicatorColor = intent ? colors[intent] : undefined;
  var minimalColors = {
    danger: _index.Colors.RED_20,
    primary: _index.Colors.MARINE_20,
    none: _index.Colors.IVORY_20,
    success: _index.Colors.GREEN_20,
    warning: _index.Colors.YELLOW_20
  };
  var minimalIndicatorColor = intent ? minimalColors[intent] : undefined;
  var indicatorTagProps = {
    intent: intent,
    minimal: minimal,
    color: minimal ? minimalIndicatorColor : indicatorColor
  };
  return /*#__PURE__*/React.createElement(_index.Tag, _extends({
    className: classes
  }, tagProps, counterTagProps, {
    rightIcon: showCount ? /*#__PURE__*/React.createElement(_index.IndicatorTag, _extends({}, indicatorTagProps, {
      text: count
    })) : undefined
  }), /*#__PURE__*/React.createElement(_index.Caption, {
    captionProps: captionProps
  }, text));
}